import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import styled from 'styled-components';
import { NewsContainer, Hero } from './styles';
import { Button } from '../../components/Button';
import { BASE_API_URL_ENDPOINT, BASE_API_DOCUMENT } from '../../api/Api';
import axios from "axios";

const DetailSection = styled.section`
  padding: 80px 0;
  .container {
    max-width: 800px;
    margin: 0 auto;
  }
  .content {
    color: ${({ theme }) => theme.colors.text};
    line-height: 1.6;
    font-size: 1.1rem;
    margin-bottom: 2rem;
  }
`;

const StepsSection = styled.section`
  padding: 80px 0;
  background-color: ${({ theme }) => theme.colors.lightGray};
  .container {
    max-width: 800px;
    margin: 0 auto;
  }
  h2 {
    color: ${({ theme }) => theme.colors.primary};
    margin-bottom: 1.5rem;
    text-align: center;
  }
  ol {
    list-style-type: decimal;
    padding-left: 20px;
    li {
      margin-bottom: 1rem;
      color: ${({ theme }) => theme.colors.text};
      font-size: 1.1rem;
      line-height: 1.5;
    }
  }
`;

const NewsDetail = () => {
  const [news, setNews] = useState([]);
  const { id } = useParams(); // Récupère l'ID depuis l'URL
  const newsId = parseInt(id, 10);
  const newsItem = news.find((item) => item.id === newsId);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    // Remplace par ton appel API réel ici
    const fetchNews = async () => {
      try {
        const response = await axios.get(`${BASE_API_URL_ENDPOINT}news`); // Exemple d'endpoint
        setNews(response.data.data);
      } catch (error) {
        console.error("Erreur de chargement des actualités :", error);
      }
    };

    fetchNews();
  }, []);

  if (!newsItem) {
    return <p>Actualité non trouvée</p>;
  }

  return (
    <NewsContainer>
      <Hero
        style={{
          background: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${BASE_API_DOCUMENT}${newsItem.image}) center/cover no-repeat`
        }}
      >
        <h1>{newsItem.title}</h1>
        <p>{formatDate(newsItem.date)}</p>
        {/* <p>{newsItem.category}</p> */}
      </Hero>

      <DetailSection>
        <div className="container">
          <div className="content">
            {newsItem.content.split('\n').map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>



          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {newsItem.category === 2 && (
              <Button as={Link} to={`/postuler/${newsItem.id}`} size="small">
                Postuler
              </Button>
            )}
            <Button as={Link} to="/news" size="small">
              Retour aux actualités
            </Button>
          </div>

        </div>
      </DetailSection>

      {newsItem.steps && newsItem.steps.length > 0 && (
        <StepsSection>
          <div className="container">
            <h2>Déroulement de l'activité</h2>
            <ol>
              {newsItem.steps.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ol>
          </div>
        </StepsSection>
      )}
    </NewsContainer>
  );
};

export default NewsDetail;
